/**
 * CSV export. Cells that a spreadsheet would evaluate (=, +, -, @, tab, CR) get a leading apostrophe
 * (OWASP CSV injection guidance); every cell is quoted and inner quotes doubled.
 */
export function csvCell(v: unknown): string {
  let s = v === null || v === undefined ? '' : typeof v === 'bigint' ? v.toString() : String(v);
  if (/^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  return `"${s.replace(/"/g, '""')}"`;
}

export function toCsv(header: readonly string[], rows: readonly (readonly unknown[])[]): string {
  return [header, ...rows].map((r) => r.map(csvCell).join(',')).join('\r\n') + '\r\n';
}
